import BusinessUnitModelBase from '../_generated/modelBases/business-unit-model-base';

export default class BusinessUnitModel extends BusinessUnitModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
